import Loadable from '@townsquare/loadable';

export const FollowGoalAction = Loadable({
	loader: () => import(/* webpackChunkName: "FollowGoalAction" */ './FollowGoalAction'),
	loading: () => null,
});
